// @ts-nocheck
import { CheckboxFieldDefinition } from "@insite/client-framework/Types/FieldDefinition";

const blockPreserveSpacingField = {
    displayName: "Preserve spacing when nested",
    editorTemplate: "CheckboxField",
    defaultValue: false,
    fieldType: "General",
} as CheckboxFieldDefinition;

export default blockPreserveSpacingField;
